import React from 'react'
import { connect } from 'react-redux'
import { BankDetail } from '@/components/demographics/bankDetail'
import { CompanyDetail } from '@/components/demographics/companyDetail'

function mapStateToProps (state, ownProps) {
  const profile = state.identity.user && state.identity.user.profile
  const match = ownProps.match
  const changeItemId = Number(match.params.id)
  const type = profile && profile.InstitutionType
  const id = changeItemId || (profile && Number(type === 'Bank' ? profile.BankId : profile.CompanyId))
  const scope = type === 'Bank' ? 'Banks' : 'Companies'
  return {
    type,
    id,
    changeItemId,
    scope,
    isChangeItemId: !!changeItemId
  }
}

export const InstitutionDetail = connect(mapStateToProps)(function InstitutionDetail ({ type, ...rest }) {
  if (type === 'Bank') return <BankDetail {...rest} />
  if (type === 'Company') return <CompanyDetail {...rest} />
  return null
})



// WEBPACK FOOTER //
// ./src/report-app/pages/institution/detail.js